var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},_vm._l((_vm.schema),function(item){return _c('DynamicComponents',{attrs:{"props":item,"formData":_vm.data},on:{"callfunction":_vm.handle_function_call}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }